export const ApplicationVI = {
    "administrative":"Hành chính",
    "myApplication":"Đơn từ của bạn",
    "myApproval":"Đơn từ bạn duyệt",
    "myDepartment":"Đơn từ phòng ban của bạn",
    "forSomeElse":"Tạo hộ người khác",
    "inout":"Check in/check out",
    "absence":"Vắng mặt",
    "resign":"Nghỉ việc",
    "shiftSwap":"Đổi ca",
    "missions":"Công tác",
    "overtime":"Làm thêm",
    "shiftMore":"Tăng ca",
    "flexible":"Làm theo chế độ",
    "leave":"Xin nghỉ",
    "shiftRegistration":"Đăng ký ca",
    "late": "Đi muộn về sớm"
}